import { Helmet } from "react-helmet-async";

export default function Seo({ title, description, noindex = false }) {
  const full = title ? `${title} — Laugh at L.A.` : "Laugh at L.A. — Live Stand-Up and Sketch Comedy Hosted by Todd Bridges";
  return (
    <Helmet>
      <title>{full}</title>
      {description && <meta name="description" content={description} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
    </Helmet>
  );
}
